import { FunctionComponent, useEffect, useState } from 'react'
import QuizContainer from './QuizContainer'
import { getQuizData } from 'Frontend/scripts/services/foodHabits.service'
import { QuizData } from 'Frontend/scripts/models/foodHabits.model'
import { Spinner } from 'react-bootstrap'

type QuizAppProps = {
  foodHabitStartPageId: string
}

interface QuizState {
  quizData: QuizData | null
  loading: boolean
  error: Error | null
}

const QuizApp: FunctionComponent<QuizAppProps> = ({ foodHabitStartPageId }) => {
  const [state, setState] = useState<QuizState>({
    quizData: null,
    loading: true,
    error: null,
  })

  useEffect(() => {
    if (!foodHabitStartPageId) {
      setState((prev) => ({ ...prev, error: new Error('Invalid start page ID'), loading: false }))
      return
    }

    const fetchQuizData = async () => {
      try {
        setState((prev) => ({ ...prev, loading: true }))
        const data = await getQuizData(foodHabitStartPageId)
        setState((prev) => ({ ...prev, quizData: data }))
      } catch (err: any) {
        setState((prev) => ({ ...prev, error: err }))
      } finally {
        setState((prev) => ({ ...prev, loading: false }))
      }
    }

    fetchQuizData()
  }, [foodHabitStartPageId])

  if (state.loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner variant="secondary" animation="border" role="status" style={{ width: '4rem', height: '4rem' }}/>
      </div>
    )
  }
  if (state.error) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div>Error: {state.error.message}</div>
      </div>
    )
  }
  if (!state.quizData) return null

  return <QuizContainer quizData={state.quizData} />
  
}

export default QuizApp
